module.exports = __webpack_public_path__ + "static/img/passion-01.d287719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-01.png
// module id = 126
// module chunks = 0